export default class MassiveSendingServiceModel {
  id: string;
  name: string;

  constructor(x?: MassiveSendingServiceModel) {
    if (typeof x === "object" && x) {
      this.id = x.id;
      this.name = x.name;
    }
    else {
      this.id = "";
      this.name = "";
    }
  }
}

